import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import numeral from 'numeral'
import { LOAN_TERM_MESSAGES } from 'src/constants/loan'

import { If, Unless } from 'src/Components'

const TWO_PLACES_OPTIONAL = '0[.]00'

const ReadableTerm = ({
  adjustable,
  armYearsInitial,
  loanType,
  termYears,
  termYearsEstimated
}) => (
  <Fragment>
    <If condition={loanType === 'HELOC'}>
      <FormattedMessage
        id='Mortgages.loans.term.heloc'
        defaultMessage='HELOC'
      />
    </If>
    <Unless condition={loanType === 'HELOC'}>
      <If condition={adjustable}>
        <FormattedMessage
          {...LOAN_TERM_MESSAGES.arm}
          values={{ years: armYearsInitial || 5 }}
        />
      </If>
      <Unless condition={adjustable}>
        <FormattedMessage
          {...LOAN_TERM_MESSAGES.fix}
          values={{
            years: numeral(termYears || termYearsEstimated).format(
              TWO_PLACES_OPTIONAL
            )
          }}
        />
      </Unless>
    </Unless>
  </Fragment>
)

export default ReadableTerm
